import "./SliderCard.scss"
import SLIDER_IMAGEN_VERDE from "../../../assets/img/SLIDER_IMAGEN_VERDE.jpg";
import FS_ABOUT_comillas from "../../../assets/img/FS-ABOUT-comillas.png";

const SliderCard = ({name, charge, personImg, rightText}) => {
  return (
    <div className="sliderCard-container grid fullColumn">
      <div className="sliderCard-left-container grid fullColumn">
        <div className="all-columns all-rows">
          <img
            src={SLIDER_IMAGEN_VERDE}
            alt="Background"
            className="all-width-height sliderCard-orange-img"
          />
        </div>
        <div className="sliderCard-left-text-container">
          <h4 className="t4 c-white">{name}</h4>
          <p className="body-18 c-white">{charge}</p>
        </div>
      </div>
      <div className="sliderCard-right-container grid fullColumn">
        <div className="sliderCard-right-text-container">
          <p className="body-18" style={{ textAlign: "left" }}>
            {rightText}
          </p>
        </div>
        <div className="sliderCard-comillas-png-container">
          <img src={FS_ABOUT_comillas} alt="Comillas" />
        </div>
      </div>
      <div className="sliderCard-person-image-container">
        <img
          src={personImg}
          alt="Person"
          className="all-width-height sliderCard-person-image"
        />
      </div>
    </div>
  );
}

export default SliderCard
